<template>
  <div :class="[rootClass, 'form-check', type === 'switch' && 'form-switch']">
    <input :id="id" class="form-check-input" type="checkbox" :value="value" @input="emitInput">
    <label :class="[`checkbox-field__label`, 'form-check-label']" :for="id">
      <slot name="label">{{ label }}</slot>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'check'
    },
    value: {
      type: [Boolean, Number],
      default: false
    }
  },
  data() {
    return {
      rootClass: 'checkbox-field'
    }
  },
  methods: {
    emitInput(ev) {
      this.$emit('input', { name: this.name, value: ev.target.value, selected: ev.target.checked })
    }
  }
}
</script>
